'use client'

import { identify, trackPage } from '@adamdotai/core/analytics'
import { FullStory, init as initFullStory } from '@fullstory/browser'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useUser } from '@/services/utils/users'

export default function AnalyticsImpl() {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const { user } = useUser()

    useEffect(() => {
        trackPage()
    }, [pathname, searchParams])

    useEffect(() => {
        identify()
    }, [user])

    useEffect(() => {
        initFullStory({ orgId: '15G06S' })
    }, [])

    useEffect(() => {
        if (!user) return

        FullStory('setIdentity', {
            uid: user.id,
            properties: {
                displayName: `${user.firstName} ${user.lastName}`,
                email: user.email,
            },
        })
    }, [user])

    return null
}
